import { Grid2Props } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';

export const GridContainer = ({ spacing = 3, children, ...props }: Grid2Props) => {
    return (
        <Grid container spacing={spacing} {...props}>
            {children}
        </Grid>
    );
};
